<script>
import { connectInfiniteHits } from "instantsearch.js/es/connectors";
import { createWidgetMixin } from "vue-instantsearch/vue3/es";

export default {
  mixins: [createWidgetMixin({ connector: connectInfiniteHits })],
  methods: {
    visibilityChanged(isVisible) {
      if (isVisible && !this.state.isLastPage) {
        this.state.showMore();
      }
    },
  },
  computed: {
    searchIsLoading() {
      return (
        this?.state?.instantSearchInstance?.status === "loading" ||
        this?.state?.instantSearchInstance?.status === "stalled"
      );
    },
    searchIsError() {
      return this?.state?.instantSearchInstance?.status === "error";
    },
  },
};
</script>

<script setup>
import NoResultsPage from "@/components/NoResultsPage.vue";
import Spinner from "@/components/helpers/Spinner.vue";
import SessionCard from "../ResultCards/SessionCard";
import SessionCard2 from "@/components/ExperiencePage/Sessions/Components/SessionCard2.vue";
import { useRouter } from "vue-router";
import { selectImageForProgram } from "./utils";
import { vElementVisibility } from "@vueuse/components";
import ApplicationExistsModal from "@/components/ExperiencePage/ApplicationExistsModal.vue";
import { displayNewCardDesign, useApplicationProgress } from "@/components/ExperiencePage/Algolia/composables.js";
import {computed} from "vue";
import {API_ENTITY_INFORMATION} from "@/constants.ts";
import {useStore} from "vuex";

const router = useRouter();

const programImageIndices = {};

const store = useStore();
const domainEntityId = computed(() => store.getters.getDomainEntityId || API_ENTITY_INFORMATION.id);

const { onApplyClicked, showApplicationTakenModal } = useApplicationProgress();

const redirectToViewPage = ({ program_page: programPage, session } = {}) => {
  router.push({
    name: "program-detail-view",
    params: { programPageId: programPage?.id },
    query: { "session-id": session?.id },
  });
};
</script>

<template>
  <div v-if="state">
    <ApplicationExistsModal
      :show-application-taken-modal="showApplicationTakenModal"
      @close="showApplicationTakenModal = false"
    />
    <div v-if="searchIsLoading && !state.hits.length > 0">
      <Spinner class="relative h-50-screen" />
    </div>
    <div
      v-if="state.hits.length > 0"
      :class="{
        'exp-grid-container justify-start lg:px-10 gap-10 lg:flex lg:flex-col flex-wrap pb-18': !displayNewCardDesign,
        'flex flex-col gap-y-8 px-5 lg:px-10 pb-18 items-center lg:items-stretch': displayNewCardDesign,
      }"
    >
      <template v-if="!displayNewCardDesign">
        <SessionCard
          v-for="hit in state.hits"
          :key="hit.objectID"
          class="programs-program-card lg:grid-cols-3"
          :program="hit"
          :horizontal="true"
          :image-url="selectImageForProgram(hit, programImageIndices)"
          event-category="Results Personalize CTA"
          @view-clicked="redirectToViewPage(hit)"
          @apply-clicked="onApplyClicked(hit)"
          :domain-entity-id="domainEntityId"
        />
      </template>
      <template v-else>
        <SessionCard2
          v-for="hit in state.hits"
          :key="hit.objectID"
          :main-container-classes="'flex flex-col max-w-25r items-stretch lg:flex-row lg:max-w-62r font-montserrat'"
          :session-data="hit"
          :horizontal="true"
          :image-url="selectImageForProgram(hit, programImageIndices)"
          @view-clicked="redirectToViewPage(hit)"
          @apply-clicked="onApplyClicked(hit)"
        />
      </template>
      <div v-element-visibility="[visibilityChanged]" />
    </div>
    <Spinner v-if="searchIsLoading && state.hits.length > 0" outer-classes="" />
    <div v-else-if="!searchIsLoading && !state.hits.length > 0">
      <NoResultsPage margin-top="mt-5" />
    </div>
  </div>
</template>
